'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.localizeGroup = localizeGroup;

var _setGlobal = require('./set-global');

var _setGlobal2 = _interopRequireDefault(_setGlobal);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function localize(key) {
    if (typeof key === 'string' && key.length > 0 && key[key.length - 1] === '#') {
        var aaKey = key + linksoft.accountingArea;
        var ret = _abp2.default.localization.localize(aaKey, 'Default');
        if (ret !== aaKey) return ret;
        key = key.substring(0, key.length - 1);
    }
    return _abp2.default.localization.localize(key, 'Default');
}

(0, _setGlobal2.default)('linksoft.localize', localize);

function localizeGroup(name) {
    return function (key) {
        return localize(name + ':' + key);
    };
}

exports.default = localize;


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/utils/localize.js
// module id = 509
// module chunks = 0